<div class="info-panel-wrapper">
  {{ currentStatus }}
</div>
